import React, { FormEvent, useContext, useState } from "react";
import { Button, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import useAlert from "../Alerts/useAlert";
import { LotDetailContext } from "../Contexts/LotDetailContext";
import { DialogInput } from "../DialogInputs";
import { handleInputChange } from "../Utilities/DialogUtils";
import { useHttpUtils } from "../Utilities/useHttpUtils";
import { DraggableModalDialog } from "./DraggableModalDialog";

interface EditHeaderTextDialogProps {
    showDialog: boolean,
    closeDialog: Function;
}

export default function EditHeaderTextDialog({ showDialog, closeDialog }: EditHeaderTextDialogProps) {
    const { t } = useTranslation();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const { lotDetail: { summary: { lotNumber, headerText } }, getLotDetail } = useContext(LotDetailContext);

    const [loading, setLoading] = useState(false);
    const [formValidated, setFormValidated] = useState(false);
    const [dialogData, setDialogData] = useState({ headerText: headerText });
    const [errors, setErrors] = useState<any>({});

    const handleSave = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        if (form.checkValidity() === true) {
            updateHeaderText();
        } else {
            console.warn("Header Text was invalid");
        }

        setFormValidated(true);
    };

    const closeDialogAndResetForm = () => {
        setFormValidated(false);
        closeDialog();
    };

    const updateHeaderText = () => {
        const url = `/api/v1/lot/${lotNumber}/headerText`;
        const body = dialogData.headerText;

        setLoading(true);
        fetchDataAuthenticated(url, 'PUT', JSON.stringify(body))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", `Updated the header text`);
                    getLotDetail();
                } else {
                    let errorMessage = await response.text();
                    console.log("Failed to update the header text: " + errorMessage);
                    throw new Error("Failed to update the header text");
                }
                closeDialog();
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onChange = (e: any) => {
        handleInputChange(e, dialogData, setDialogData, errors, setErrors);
    };

    return (
        <>
            <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialogAndResetForm} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t<string>("Dialogs.HeaderText")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading
                        ?
                        <div className="d-flex justify-content-center mb-2">
                            <Spinner animation="border" />
                        </div>
                        :
                        <Form id="setHeaderText" noValidate validated={formValidated} onSubmit={handleSave}>
                            <Form.Group as={Row} className="mb-2">
                                <DialogInput controlId="formHeaderText" title="Header Text" name="headerText" value={dialogData.headerText} onChange={onChange} placeholder={undefined} error={errors.headerText} />
                            </Form.Group>
                        </Form>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDialogAndResetForm} disabled={loading}>
                        {t<string>("Application.Controls.Cancel")}
                    </Button>
                    <Button variant="primary" type="submit" form="setHeaderText" disabled={loading}>
                        {t<string>("Application.Controls.Save")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}